import { add } from 'date-fns';

export const toGMT7 = (date: string | Date) => add(date, { hours: 7 });
